import React from "react";

export default function HelpLinkView({ link }: { link?: string }) {
    return link
        ? <a data-component={ HelpLinkView.name } href={ link } rel={ "noreferrer" } target={ "_blank" } title={ "Help about this page" }><i className={ "question circle icon" }/></a>
        : <></>;
}
